"use client"

import { create } from "zustand"

import type { Locale } from "@/i18n"

export type BlockingMutation =
  | {
      token: string
      kind: "language-change"
      targetLocale: Locale
    }
  | {
      token: string
      kind: "project-create"
    }

interface MutationBlockerState {
  activeMutation: BlockingMutation | null
  activateMutation: (mutation: BlockingMutation) => void
  clearMutation: (token?: string) => void
}

export const useMutationBlockerStore = create<MutationBlockerState>()((set) => ({
  activeMutation: null,
  activateMutation: (mutation) => set({ activeMutation: mutation }),
  clearMutation: (token) =>
    set((state) => {
      if (!state.activeMutation) {
        return state
      }

      if (token && state.activeMutation.token !== token) {
        return state
      }

      return { activeMutation: null }
    }),
}))
